// test2528
(2528 && 0);
